import { combineReducers } from 'redux'
import browser from './browser'
import router from './router'

const appReducer = combineReducers({ browser, location: router })

export default appReducer
